export default __webpack_public_path__ + "maps-guides-styles-layers-symbol-layer-icon-960-57383a1d0a3cfa1c59e731d3b093bc5b.png";